/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetGroupMembersCounts$Request {
    accountId: number;
    requestBody: Array<number>;
}

export interface GetGroupMembersCounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGroupMembersCountsRequest = createAction<PayloadData<void, GetGroupMembersCounts$Request>>('GET_GROUPS_MEMBERS_COUNTS__GET_GROUP_MEMBERS_COUNTS__REQUEST');
export const getGroupMembersCountsSuccess = createAction<PayloadData<{ [key: string]: string; }, GetGroupMembersCounts$Request>>('GET_GROUPS_MEMBERS_COUNTS__GET_GROUP_MEMBERS_COUNTS__SUCCESS');
export const getGroupMembersCountsFailure = createAction<PayloadData<Error, GetGroupMembersCounts$Request, true>>('GET_GROUPS_MEMBERS_COUNTS__GET_GROUP_MEMBERS_COUNTS__FAILURE');

export const getGroupMembersCountsActions = [
    getGroupMembersCountsRequest,
    getGroupMembersCountsSuccess,
    getGroupMembersCountsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGroupMembersCounts = (meta: GetGroupMembersCounts$Request, config?: GetGroupMembersCounts$Config) => {
    return {
        CALL_API: {
            types: getGroupMembersCountsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/groups/members-counts`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

